

module.exports = __webpack_require__.stylable.create(
    "HeroImage1803579920",
    {"classes":{"root":"HeroImage1803579920__root","overrideStyleParams":"HeroImage1803579920__overrideStyleParams"},"vars":{},"stVars":{"defaultBackgroundColor":"color-5","BackgroundColor":"--overridable","ImageOpacity":"--overridable","backgroundColor":"\"color(fallback(--overridable, color-5))\"","imageOpacity":"\"fallback(--overridable, 100%)\""},"keyframes":{}},
    "",
    4,
    "HeroImage1803579920",
    null
);
